import React from 'react';
import { CTAButton } from './CTAButton';
import { Book } from 'lucide-react';
export function HeroSection() {
  const scrollToBuy = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-marfil flex flex-col items-center px-4 pt-2 pb-6 min-h-[100svh] max-h-[844px] overflow-hidden relative" data-id="element-56">
      {/* Navbar - Max 48px */}
      <nav className="w-full max-w-md h-10 flex items-center justify-center mb-2" data-id="element-57">
        <span className="font-serif font-bold text-petroleo text-lg tracking-tight" data-id="element-58">
          Biología Femenina
        </span>
      </nav>

      <div className="w-full max-w-md flex flex-col flex-grow justify-center items-center text-center gap-3" data-id="element-59">
        {/* Badge - Max 28px */}
        <div className="h-7 px-3 bg-salvia-light text-salvia rounded-full flex items-center justify-center text-xs font-semibold border border-salvia/20" data-id="element-60">
          Protocolo usado por +500 mujeres argentinas
        </div>

        {/* Headline - Max 3 lines */}
        <h1 className="font-serif font-black text-petroleo text-4xl leading-[1.1] tracking-tight" data-id="element-61">
          Apagá el fuego de la Endo en 21 días.
        </h1>

        {/* Subheadline - Max 2 lines */}
        <p className="font-sans text-gray-700 text-[16px] leading-snug px-2" data-id="element-62">
          Un protocolo antiinflamatorio diseñado para la realidad argentina. Sin
          pastillas extra. Sin dietas imposibles.
        </p>

        {/* Image / Mockup - Above CTA, compact */}
        <div onClick={scrollToBuy} className="w-full max-h-[140px] bg-white rounded-2xl shadow-sm border border-blush-light flex items-center justify-center cursor-pointer overflow-hidden relative group py-4" data-id="element-63">
          <div className="absolute inset-0 bg-gradient-to-br from-salvia-light/40 to-blush-light/40" data-id="element-64" />
          <div className="relative z-10 flex items-center gap-3" data-id="element-65">
            <Book className="w-12 h-12 text-petroleo group-hover:scale-105 transition-transform" data-id="element-66" />
            <div className="text-left" data-id="element-67">
              <span className="font-serif font-bold text-petroleo text-base block leading-tight" data-id="element-68">
                Protocolo Endo-Rescate
              </span>
              <span className="text-xs text-gray-500" data-id="element-69">
                6 Tomos · PDF Descargable
              </span>
            </div>
          </div>
        </div>

        {/* CTA Area */}
        <div className="w-full mt-1 flex flex-col gap-2" data-id="element-70">
          <CTAButton text="Quiero mi Protocolo — $19.990" data-id="element-71" />
          <p className="text-[12px] text-gray-500 font-medium" data-id="element-72">
            Descarga inmediata · Pago seguro · Garantía 7 días
          </p>
        </div>
      </div>
    </section>;
}